<template>
    <div>
        <v-overlay :value="checkingCustomer">
            <v-progress-circular indeterminate size="64" color="primary"></v-progress-circular>
        </v-overlay>
    </div>
</template>

<script>
    import {mapGetters, mapActions} from 'vuex'

    export default {
        name: 'CheckCustomer',
        mounted() {
            let customerId = this.$router.currentRoute.params.id;
            if (typeof customerId === 'undefined' || !customerId.length) {
                this.$router.push('/');
                return;
            }

            this.checkCustomer({customer: customerId});
        },
        computed: {
            ...mapGetters([
                'checkingCustomer'
            ])
        },
        methods: {
            ...mapActions([
                'checkCustomer'
            ])
        }
    }
</script>
